import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    iPurchaseOrder,
 
    iPurchaseOrderResponse,
    orderStatus
} from '../../..//services/api/api'
// Models
interface iItem {
 
    totall_area?:number,
    width?:number,
    length?:number,
    totall_cheques?:number,
    cheques_number?:number,
    boxes_number?:number,
    description?:string,
    category?:string,
    category_code?:string,

    

}


// Materials state
interface iOrder {[key:number]:iPurchaseOrderResponse[]}

export interface orderState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    showOrder: boolean,
    order?: iPurchaseOrderResponse,
    orders: iOrder,
    page:number,

}

const initialMaterialsState: orderState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    showOrder: false,
    order: {id:0 ,purchaseorderdetail:[]},
    orders: {},
    page:1,
    
}

// Users slice
export const purchaseOrdersSlice = createSlice({
    name: 'purchaseOrders',
    initialState: initialMaterialsState,
    reducers: {
        init:(state,{payload}:PayloadAction<iPurchaseOrderResponse[]>)=>{
            state.orders[state.page]=payload
        }
        ,
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
            state.isFetching = payload
        },
        setHasMore: (state, { payload }: PayloadAction<boolean>) => {
            state.hasMore = payload
        },
        setOrder: (state, { payload }: PayloadAction<{ showOrder: boolean, order?: iPurchaseOrderResponse }>) => {
          
            state.showOrder = payload.showOrder
                state.order = payload.order?payload.order:{id:0}
        },
        addOrder: (state, { payload }: PayloadAction<iPurchaseOrderResponse[]>) => {
            
            state.orders [state.page]=    state.orders [state.page]?
            [ ...state.orders [state.page],...payload]:[...payload]
        
        },
        updateOrder: (state, { payload }: PayloadAction<iPurchaseOrderResponse>) => {
          
            let index =    state.orders[state.page].findIndex(order => order.id === payload.id)
           
            if (index !== -1)
            state.orders [state.page][index] = payload
        },
        deleteMaterials: (state, { payload }: PayloadAction<number[]>) => {
            payload.map(id => {
                let index =    state.orders [state.page].findIndex(material => material.id === id)
                if (index != -1)
                state.orders [state.page].splice(index, 1)
            })
        },
        setOrderPurchaseAgreement:(state,{payload}:PayloadAction<{id:number,value:orderStatus}>)=>{
            let target =state.orders[state.page].find(ele=>ele.id === payload.id)
         
            if (target) target.order_status=payload.value
        },
         updateInvoiceIssued:(state,{payload}:PayloadAction<{ id: number, invoice_issued: number }>)=>{
             let index = state.orders[state.page].findIndex(order => order.id === payload.id)
        
             if (index !== -1) state.orders[state.page][index].invoice_issued=payload.invoice_issued
          },
        reset: (state) => {
            state.orders = []
            state.hasMore = true
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        },
       
    }
})